/* eslint-disable no-console */
import logError from 'utils/errorUtils';

/**
 * Creates a Forage PIN element for EBT PIN collection
 */
export const createPinElement = ({ elementID, forage, onChange, onReady }) => {
    if (!forage) {
        return Promise.reject(new Error('Forage instance not initialized'));
    }

    return new Promise((resolve, reject) => {
        try {
            const container = document.getElementById(elementID);
            if (!container) {
                reject(new Error('ForagePinElement container not found'));
                return;
            }

            const element = forage.create('collect_pin');

            element.mount(elementID);

            element.on('ready', () => {
                onReady?.(element);
                resolve(element);
            });

            element.on('change', (event) => {
                onChange?.(event);
            });
        } catch (error) {
            logError(error, { elementID });
            reject(error);
        }
    });
};

/**
 * Destroys the Forage PIN element
 */
export const destroyPinElement = (element) => {
    if (!element) return;

    try {
        element.destroy();
    } catch (error) {
        console.error('❌ Error destroying ForagePinElement:', error);
    }
};
